<template>
  <div class="ma-4 px-4">
    <v-row>
      <v-col cols="12" md="3" class="pt-3 my-0">
        <v-text-field
          v-model="form.usn_id"
          outlined
          dense
          clearable
          hide-details="auto"
          label="USN"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" class="d-flex justify-start">
        <v-btn
          class="accent white--text"
          :loading="loading"
          @click="getStudentRequests()"
          :disabled="loading"
        >
          Search
        </v-btn>
        <v-btn
          v-if="tab == 3"
          class="accent white--text ml-3"
          :loading="downloadloading"
          @click="download"
          :disabled="downloadloading"
        >
          Download
        </v-btn>
        <v-btn
          v-if="tab == 0"
          small
          fab
          @click="bulkRequestDialog = true"
          class="accent white--text ml-2"
        >
          <v-icon small>mdi-upload</v-icon>
        </v-btn>
        <v-btn
          v-if="tab == 3"
          small
          fab
          @click="uploadDialog = true"
          class="accent white--text ml-2"
        >
          <v-icon small>mdi-upload</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10">
        <v-tabs v-model="tab" @change="onTabChange">
          <v-tab key="pending">Pending</v-tab>
          <v-tab key="approved">Approved</v-tab>
          <v-tab key="rejected">Rejected</v-tab>
          <v-tab key="completed">Completed</v-tab>
        </v-tabs>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="2" class="d-flex justify-end">
        <v-btn
          class="accent white--text"
          :loading="loading"
          @click="openBulkApproveDialog()"
          :disabled="loading || !selectedRows.length"
        >
          Approve
        </v-btn>
      </v-col> 
    </v-row>

    <v-tabs-items class="mt-4" v-model="tab">
      <v-tab-item
        v-for="(tabKey, index) in tabKeys"
        :key="tabKey"
        :eager="index === 0"
      >
        <v-row>
          <v-col cols="12">
            <v-sheet outlined>
              <v-data-table
              v-model="selectedRows"
              :show-select="tab === 0"
                :headers="headers"
                :search="search"
                :items="filteredRequests"
                :custom-filter="customFilter"
                :loading="loading"
                fixed-header
                class="secondary row-height-50"
                :footer-props="{
                  'items-per-page-options': [10, 25, 50, 100],
                  'show-current-page': true,
                }"
              >
                <template #[`item.id`]="{ value }">
                  <strong class="blue--text">#{{ value }}</strong>
                </template>

                <template #[`item.usn_id`]="{ value }">
                  {{ value }}
                </template>

                <template #[`item.student_name`]="{ item }">
                  <div>
                    <strong>{{ item.student_info?.name || "N/A" }}</strong>
                    <div class="caption text-grey">
                      {{ item.student_info?.email || "" }}
                    </div>
                  </div>
                </template>

                <template #[`item.particulars`]="{ item }">
                  <span v-if="item.particulars.length < 2">
                    <div class="mb-1">
                      <div
                        v-for="(id, index) in item.particulars"
                        :key="index"
                        class="text-sm"
                      >
                        • {{ getDocumentName(id) }}
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    <v-btn
                      text
                      fab
                      small
                      @click="
                        (viewDocumentDialog = true),
                          (currentDocument = item.particulars)
                      "
                      ><v-icon>mdi-dots-horizontal</v-icon></v-btn
                    >
                  </span>
                </template>

                <template #[`item.is_postal_required`]="{ item }">
                  <v-chip
                    small
                    class="white--text"
                    :color="item.is_postal_required ? 'green darken-1' : 'grey'"
                  >
                    {{ item.is_postal_required ? "Yes" : "No" }}
                  </v-chip>
                </template>

                <template #[`item.status`]="{ value }">
                  <v-chip
                    small
                    :class="getStatusColor(value)"
                    class="white--text"
                  >
                    {{ value }}
                  </v-chip>
                </template>

                <template #[`item.total_amount`]="{ item }">
                  <strong class="green--text text--darken-2">
                    ₹{{ item.amount || getTotalAmount(item) }}
                  </strong>
                </template>

                <template #[`item.action`]="{ item }">
                  <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <v-icon
                        small
                        class="mr-2"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="viewDetails(item)"
                      >
                        mdi-eye
                      </v-icon>
                    </template>
                    <span>View Details</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-sheet>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="viewDialog" width="700" persistent>
      <v-card v-if="selectedRequest">
        <v-card-title class="text-subtitle-1 primary white--text py-3">
          <span>Request Detail</span>
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <div class="mb-4 pa-3 rounded">
            <v-row>
              <v-col cols="12" class="mb-3 rounded">
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <strong>Name:</strong>
                    {{ selectedRequest.student_info?.name || "N/A" }}
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <strong>USN:</strong> {{ selectedRequest.usn_id }}
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <strong>Email:</strong>
                    {{ selectedRequest.student_info?.email || "N/A" }}
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <strong>Mobile:</strong>
                    {{ selectedRequest.student_info?.mobile_no || "N/A" }}
                  </v-col>
                  <v-col cols="12" class="pb-0">
                    <strong>Additional Notes:</strong>
                    {{ selectedRequest.description || "N/A" }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row
              v-if="
                selectedRequest.status === 'Rejected' && selectedRequest.remarks
              "
            >
              <v-col cols="12">
                <v-alert type="error" dense outlined class="mb-0">
                  <div class="text-caption font-weight-bold mb-1">
                    Rejection Reason: {{ selectedRequest.remarks }}
                  </div>
                </v-alert>
              </v-col>
            </v-row>
          </div>

          <div
            class="text-subtitle-1 font-weight-bold mt-4 px-3"
            v-if="selectedRequest.student_info?.postal_address?.address_line1"
          >
            Postal Address
          </div>

          <div
            v-if="selectedRequest.student_info?.postal_address?.address_line1"
            class="px-3"
          >
            {{
              [
                selectedRequest.student_info.postal_address.address_line1,
                selectedRequest.student_info.postal_address.address_line2,
                selectedRequest.student_info.postal_address.locality,
                selectedRequest.student_info.postal_address.city,
                selectedRequest.student_info.postal_address.state,
                selectedRequest.student_info.postal_address.country,
              ]
                .filter(Boolean)
                .join(", ")
                .replace(/,([^,]+),([^,]+) /g, "$1 $2")
            }}
            - {{ selectedRequest.student_info.postal_address.postcode }}
          </div>

          <div class="text-subtitle-1 font-weight-bold mt-4 px-3">
            Document Details
          </div>
          <v-simple-table dense class="mb-4 mt-3">
            <template #default>
              <thead>
                <tr>
                  <th class="text-left">Document</th>
                  <th class="text-center" width="130">Fee(in ₹)</th>
                  <th class="text-center" width="130">Search Fee(in ₹)</th>
                  <th class="text-right" width="130">Subtotal(in ₹)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="docId in selectedRequest.particulars" :key="docId">
                  <td class="text-body-2">{{ getDocumentName(docId) }}</td>
                  <td class="text-center">
                    <span v-if="docId">{{ getDocumentFee(docId) }}</span>
                    <span v-else class="text-secondary">--</span>
                  </td>
                  <td class="text-center">
                    <span v-if="selectedRequest.status !== 'Pending'">
                      {{
                        getApprovedSearchFee(
                          selectedRequest,
                          getDocumentName(docId),
                        )
                      }}
                    </span>
                    <v-text-field
                      v-else-if="isSearchFeeApplicable(docId)"
                      :value="getSearchFee(docId)"
                      prefix="₹"
                      dense
                      hide-details
                      type="number"
                      :readonly="selectedRequest.status !== 'Pending'"
                      class="compact-field"
                      @input="updateSearchFee(docId, $event)"
                    />
                    <span v-else class="text--secondary">-</span>
                  </td>
                  <td class="text-right text-body-2 font-weight-medium">
                    <span v-if="selectedRequest.status === 'Pending'">
                      {{ getDocumentSubtotal(docId) }}
                    </span>
                    <span v-else>
                      {{
                        calculateApprovedSubtotal(docId, getDocumentName(docId))
                      }}
                    </span>
                  </td>
                </tr>

                <tr
                  v-if="selectedRequest.is_postal_required"
                  class="grey lighten-5"
                >
                  <td colspan="3" class="text-right font-weight-medium">
                    Postal Charges:
                  </td>
                  <td class="text-right">
                    <span v-if="selectedRequest.status !== 'Pending'">
                      ₹{{ getApprovedPostalFee(selectedRequest) }}
                    </span>
                    <v-text-field
                      v-else
                      v-model.number="postalCharges"
                      prefix="₹"
                      dense
                      hide-details
                      type="number"
                      :readonly="selectedRequest.status !== 'Pending'"
                      class="compact-field"
                    />
                  </td>
                </tr>

                <tr>
                  <td colspan="3" class="text-right">
                    <strong>Total Amount:</strong>
                  </td>
                  <td class="text-right">
                    <span v-if="selectedRequest.status !== 'Pending'">
                      ₹{{ getApprovedTotal(selectedRequest) }}
                    </span>
                    <v-text-field
                      v-else
                      v-model.number="confirmAmount"
                      prefix="₹"
                      dense
                      hide-details
                      type="number"
                      :readonly="selectedRequest.status !== 'Pending'"
                      class="compact-field font-weight-bold"
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div v-if="selectedRequest.status === 'Completed'" class="mt-4">
            <div class="text-subtitle-1 font-weight-bold mt-4 px-3">
              Tracking Details
            </div>
            <v-row dense class="pl-3 pt-2">
              <v-col cols="4">
                <v-text-field
                  v-model="selectedRequest.tracking_id"
                  label="Tracking ID"
                  :rules="[rules.required]"
                  dense
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="selectedRequest.courier_name"
                  label="Courier Name"
                  :rules="[rules.required]"
                  dense
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-menu
                  v-model="showDispatchDatePicker"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedDispatchDate"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      label="Dispatch Date*"
                      outlined
                      dense
                      hide-details
                    />
                  </template>
                  <v-date-picker
                    v-model="selectedRequest.dispatch_date"
                    :max="minDate"
                    @input="showDispatchDatePicker = false"
                  />
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="selectedRequest.postal_tracking_notes"
                  label="Remarks"
                  dense
                  rows="2"
                  hide-details
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row justify="end" class="mx-0 my-0 mt-2">
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                :disabled="selectedRequest.status !== 'Completed'"
                :loading="savingTrackingDetails"
                @click="saveTrackingDetails"
              >
                Save
              </v-btn>
            </v-row>
          </div>
          <v-row
            v-if="
              selectedRequest.status === 'Pending' ||
              selectedRequest.status === 'Approved'
            "
            dense
            class="mb-3"
          >
            <v-col cols="4">
              <v-menu
                v-model="showStartDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formattedFromDate"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    label="Pay Start Date*"
                    outlined
                    dense
                    :disabled="selectedRequest.status != 'Pending'"
                    hide-details
                  />
                </template>
                <v-date-picker
                  v-model="selectedRequest.pay_start_date"
                  :min="minDate"
                  @input="showStartDatePicker = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="showEndDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formattedToDate"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    label="Pay End Date*"
                    outlined
                    dense
                    hide-details
                    :disabled="
                      !selectedRequest.pay_start_date ||
                      selectedRequest.status != 'Pending'
                    "
                  />
                </template>
                <v-date-picker
                  v-model="selectedRequest.pay_end_date"
                  :min="selectedRequest.pay_start_date"
                  @input="showEndDatePicker = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="4" class="d-flex align-center">
              <v-checkbox
                v-model="selectedRequest.is_postal_required"
                label="Postal Fee Required"
                :readonly="selectedRequest.status !== 'Pending'"
                dense
                hide-details
                class="mt-n0"
                @change="handlePostalFeeChange"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions
          v-if="
            selectedRequest.status === 'Pending' ||
            selectedRequest.status === 'Approved'
          "
          class="pa-4 pt-0"
        >
          <v-spacer />
          <v-btn
            color="green darken-1 white--text"
            depressed
            :loading="approvalLoading"
            :disabled="!isFormValid"
            @click="handleApprove"
          >
            Send Invoice
          </v-btn>
          <v-btn
            color="red darken-1 white--text "
            depressed
            :loading="rejectLoading"
            @click="openRejectDialog"
          >
            Reject
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="rejectDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1"> Reject Request </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="rejectionReason"
            label="Reason for Rejection*"
            outlined
            rows="3"
            :rules="[(v) => !!v || 'Rejection reason is required']"
            hide-details="auto"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="closeRejectDialog">Cancel</v-btn>
          <v-btn
            color="red darken-1 white--text"
            depressed
            :loading="rejectLoading"
            :disabled="!rejectionReason || !rejectionReason.trim()"
            @click="handleReject"
          >
            Confirm Rejection
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="viewDocumentDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">
          View Documents
          <v-spacer></v-spacer>
          <v-btn icon large @click="viewDocumentDialog = false">
            <v-icon small color="red">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div
            v-for="(id, index) in currentDocument"
            :key="index"
            class="text-sm"
          >
            • {{ getDocumentName(id) }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bulkRequestDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="primary white--text font-weight-medium">
          Upload Bulk Request
          <v-spacer></v-spacer>
          <v-btn icon large @click="bulkRequestDialog = false">
            <v-icon small color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <!-- Instructions Section -->
          <div class="mb-4">
            <h3 class="font-weight-medium mb-2">Instructions:</h3>
            <ol class="pl-4" style="line-height: 1.8">
              <li>
                Download the template using the button below <br />
                <v-btn
                  class="mb-2 primary white--text"
                  outlined
                  @click="downloadBulkRequestTemplate"
                >
                  <v-icon color="white" left>mdi-download</v-icon>
                  Download Template
                </v-btn>
              </li>
              <li>Do not change the column names.</li>
              <li>
                If Applicable, Request Particulars can be comma separated or a
                single name. The particular name should be the same as in the
                Miscellaneous Fee Configuration.
              </li>
              <li>
                If Applicable, Transaction Date should be in DD-MM-YYYY format
              </li>
              <li>Upload the updated template using the Upload button</li>
            </ol>
          </div>

          <div class="d-flex align-center">
            <v-btn
              color="success"
              :loading="loading"
              @click="triggerBulkFileUpload"
            >
              <v-icon left>mdi-upload</v-icon>
              Upload
            </v-btn>
            <input
              ref="bulkFileInput"
              type="file"
              accept=".csv,.xlsx,.xls"
              style="display: none"
              @change="handleBulkFileUpload"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="primary white--text font-weight-medium">
          Upload Tracking Details
          <v-spacer></v-spacer>
          <v-btn icon large @click="uploadDialog = false">
            <v-icon small color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <!-- Instructions Section -->
          <div class="mb-4">
            <h3 class="font-weight-medium mb-2">Instructions:</h3>
            <ol class="pl-4" style="line-height: 1.8">
              <li>
                Download the template using the button below <br />
                <v-btn
                  class="mb-2 primary white--text"
                  outlined
                  @click="downloadTemplate"
                >
                  <v-icon color="white" left>mdi-download</v-icon>
                  Download Template
                </v-btn>
              </li>
              <li>
                Only change the fields for:
                <ul class="pl-4 mt-1" style="list-style-type: circle">
                  <li>Tracking ID</li>
                  <li>Courier Name</li>
                  <li>Dispatch Date</li>
                  <li>Remarks(optional)</li>
                </ul>
              </li>
              <li class="font-weight-bold red--text">
                Do NOT change the USN field.
              </li>
              <li>Do not change the column names.</li>
              <li>Upload the updated template using the Upload button</li>
              <li>Dispatch Date should be in DD-MM-YYYY format</li>
            </ol>
          </div>

          <div class="d-flex align-center">
            <v-btn
              color="success"
              :loading="loading"
              @click="triggerFileUpload"
            >
              <v-icon left>mdi-upload</v-icon>
              Upload
            </v-btn>
            <input
              ref="fileInput"
              type="file"
              accept=".csv,.xlsx,.xls"
              style="display: none"
              @change="handleFileUpload"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bulkApproveDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="primary white--text">
          Bulk Approve Requests
          <v-spacer></v-spacer>
          <v-btn icon @click="bulkApproveDialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <!-- Selected Count -->
          <div class="mb-4">
            <strong>Selected Students:</strong>
            {{ selectedRows.length }}
          </div>

          <v-row>
            <v-col cols="6">
              <v-menu
                v-model="showBulkStartDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formattedBulkFromDate"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    label="Pay Start Date*"
                    outlined
                    dense
                    hide-details
                  />
                </template>

                <v-date-picker
                  v-model="bulkFromDate"
                  :min="minDate"
                  @input="showBulkStartDatePicker = false"
                />
              </v-menu>
            </v-col>

            <!-- To Date -->
            <v-col cols="6">
              <v-menu
                v-model="showBulkEndDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formattedBulkToDate"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    label="Pay End Date*"
                    outlined
                    dense
                    hide-details
                    :disabled="!bulkFromDate"
                  />
                </template>

                <v-date-picker
                  v-model="bulkToDate"
                  :min="bulkFromDate"
                  @input="showBulkEndDatePicker = false"
                />
              </v-menu>
            </v-col>
          </v-row>
          <v-row
            ><span class="mx-2"
              >Note: Before processing bulk approval, Kindly ensure the fee
              payable amount matching as per the miscellaneous fee configuration
              (Bulk Upload Requests).</span
            ></v-row
          >
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class="white--text"
            :disabled="!bulkFromDate || !bulkToDate"
            @click="submitBulkApprovalStatus('Approved')"
          >
            Send Invoice
          </v-btn>
          <v-btn
            color="red darken-1"
            class="white--text"
            @click="submitBulkApprovalStatus('Rejected')"
          >
            Reject
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { studentRequestHeaders } from "@/constants/headers";
import { rules } from "@/helpers/rules";

export default {
  name: "StudentDocumentRequests",

  data() {
    return {
      rules,
      tab: 0,
      tabKeys: ["pending", "approved", "rejected", "completed"],
      viewDialog: false,
      rejectDialog: false,
      rejectionReason: "",
      selectedRequest: null,
      search: "",
      studentRequests: [],
      documentFees: {},
      documentMap: {},
      documentFeeOverrides: {},
      searchFeeOverrides: {},
      headers: studentRequestHeaders,
      documentMapLoaded: false,
      confirmAmount: 0,
      postalCharges: 0,
      loading: false,
      approvalLoading: false,
      rejectLoading: false,
      statusMap: {
        0: "Pending",
        1: "Approved",
        2: "Rejected",
        3: "Completed",
      },
      showStartDatePicker: false,
      showEndDatePicker: false,
      showDispatchDatePicker: false,
      savingTrackingDetails: false,
      viewDocumentDialog: false,
      currentDocument: null,
      form: {},
      allParticulars: [],
      downloadloading: false,
      uploadDialog: false,
      bulkRequestDialog: false,
      selectedRows: [],
      bulkApproveDialog: false,
      bulkFromDate: null,
      bulkToDate: null,
      showBulkStartDatePicker: false,
      showBulkEndDatePicker: false,
    };
  },

  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    filteredRequests() {
      return this.studentRequests;
    },

    currentStatus() {
      return this.statusMap[this.tab];
    },

    minDate() {
      return this.currentDate(new Date());
    },

    formattedFromDate() {
      if (!this.selectedRequest?.pay_start_date) return "";
      const [year, month, day] = this.selectedRequest.pay_start_date.split("-");
      return `${day}-${month}-${year}`;
    },

    formattedToDate() {
      if (!this.selectedRequest?.pay_end_date) return "";
      const [year, month, day] = this.selectedRequest.pay_end_date.split("-");
      return `${day}-${month}-${year}`;
    },
    formattedBulkFromDate() {
      if (!this.bulkFromDate) return "";
      const [year, month, day] = this.bulkFromDate.split("-");
      return `${day}-${month}-${year}`;
    },

    formattedBulkToDate() {
      if (!this.bulkToDate) return "";
      const [year, month, day] = this.bulkToDate.split("-");
      return `${day}-${month}-${year}`;
    },

    formattedDispatchDate() {
      if (!this.selectedRequest?.dispatch_date) return "";
      const [year, month, day] = this.selectedRequest.dispatch_date.split("-");
      return `${day}-${month}-${year}`;
    },

    isFormValid() {
      return (
        this.confirmAmount > 0 &&
        this.selectedRequest?.pay_start_date &&
        this.selectedRequest?.pay_end_date
      );
    },
  },

  watch: {
    postalCharges() {
      this.recalculateTotal();
    },
  },

  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Requests" }]);
    this.initialize();
  },

  methods: {
    async saveTrackingDetails() {
      this.savingTrackingDetails = true;
      const response = await this.$axios.put(
        `student_document_requests/${this.selectedRequest.id}`,
        { student_document_request: this.selectedRequest },
      );
      this.showSuccess(
        response.data.data || "Tracking details updated successfully",
      );
      this.savingTrackingDetails = false;
      this.closeDialog();
      await this.getStudentRequests();
    },
    async initialize() {
      await Promise.all([this.getDocumentFees(), this.getStudentRequests()]);
    },

    async onTabChange() {
      this.loading = true;
      this.form.usn_id = null;
      await this.getStudentRequests();
      this.loading = false;
      this.selectedRows = [];
    },

    async getStudentRequests() {
      this.loading = true;
      this.studentRequests = [];
      this.form.status = this.currentStatus;
      const queryString = this.objectToQueryParams({
        ...this.form,
      });

      try {
        const res = await this.$axios.get(
          `student_document_requests?${queryString}`,
        );
        this.studentRequests = (res.data.data || []).sort(
          (a, b) => b.id - a.id,
        );
      } catch (error) {
        this.showError("Failed to fetch Requests", error);
      } finally {
        this.loading = false;
      }
    },

    objectToQueryParams(obj) {
      return Object.keys(obj)
        .filter(
          (key) =>
            obj[key] !== undefined && obj[key] !== null && obj[key] !== "",
        )
        .map(
          (key) => encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]),
        )
        .join("&");
    },

    async getDocumentFees() {
      if (this.documentMapLoaded) return;

      try {
        const res = await this.$axios.get("miscellaneous_fees");
        const documents = (res.data.data || []).sort((a, b) => a.id - b.id);
        this.allParticulars = documents;

        documents.forEach((doc) => {
          this.documentMap[doc.id] = doc.particular;
          this.documentFees[doc.id] = {
            fee: doc.fee || 0,
            postal_fee: doc.postal_fee || 0,
            search_fee: doc.search_fee || 0,
            search_fee_applicable: doc.search_fee_applicable || false,
            postal_fee_applicable: doc.postal_fee_applicable || false,
          };
        });

        this.documentMapLoaded = true;
      } catch (error) {
        this.showError("Failed to fetch document fees", error);
      }
    },

    getDocumentName(id) {
      return this.documentMap[id] || `Document ${id}`;
    },

    getDocumentFee(docId) {
      return (
        this.documentFeeOverrides[docId] ?? this.documentFees[docId]?.fee ?? 0
      );
    },

    getSearchFee(docId) {
      return (
        this.searchFeeOverrides[docId] ??
        this.documentFees[docId]?.search_fee ??
        0
      );
    },

    updateDocumentFee(docId, value) {
      this.$set(this.documentFeeOverrides, docId, parseFloat(value) || 0);
      this.recalculateTotal();
    },

    updateSearchFee(docId, value) {
      this.$set(this.searchFeeOverrides, docId, parseFloat(value) || 0);
      this.recalculateTotal();
    },

    isSearchFeeApplicable(docId) {
      return this.documentFees[docId]?.search_fee_applicable || false;
    },

    getDocumentSubtotal(docId) {
      const docFee = this.getDocumentFee(docId);
      const searchFee = this.isSearchFeeApplicable(docId)
        ? this.getSearchFee(docId)
        : 0;
      return docFee + searchFee;
    },

    calculateDocumentTotal(item) {
      return item.particulars.reduce((total, docId) => {
        return total + this.getDocumentSubtotal(docId);
      }, 0);
    },

    getTotalAmount(item) {
      const documentTotal = this.calculateDocumentTotal(item);
      const postal = item.is_postal_required ? this.postalCharges || 0 : 0;
      return documentTotal + postal;
    },

    recalculateTotal() {
      if (!this.selectedRequest) return;
      const documentTotal = this.calculateDocumentTotal(this.selectedRequest);
      const postal = this.selectedRequest.is_postal_required
        ? this.postalCharges || 0
        : 0;
      this.confirmAmount = documentTotal + postal;
    },

    getStatusColor(status) {
      const colors = {
        Pending: "orange",
        Approved: "green",
        Completed: "green darken-2",
        Rejected: "red darken-2",
      };
      return colors[status] || "grey";
    },

    viewDetails(item) {
      this.viewDialog = true;
      this.selectedRequest = { ...item };

      this.documentFeeOverrides = {};
      this.searchFeeOverrides = {};

      this.postalCharges =
        item.postal_charges || this.getDefaultPostalCharges(item);

      this.confirmAmount = item.amount || this.getTotalAmount(item);
    },

    getDefaultPostalCharges(item) {
      if (!item.is_postal_required) return 0;

      for (const docId of item.particulars) {
        const fee = this.documentFees[docId];
        if (fee?.postal_fee_applicable && fee.postal_fee) {
          return fee.postal_fee;
        }
      }
      return 0;
    },

    closeDialog() {
      this.viewDialog = false;
      this.selectedRequest = null;
      this.confirmAmount = 0;
      this.postalCharges = 0;
      this.documentFeeOverrides = {};
      this.searchFeeOverrides = {};
    },

    openRejectDialog() {
      this.rejectionReason = "";
      this.rejectDialog = true;
    },

    closeRejectDialog() {
      this.rejectDialog = false;
      this.rejectionReason = "";
    },

    handlePostalFeeChange() {
      if (!this.selectedRequest.is_postal_required) {
        this.postalCharges = 0;
      } else {
        this.postalCharges = this.getDefaultPostalCharges(this.selectedRequest);
      }
      this.recalculateTotal();
    },

    buildDocumentAmountDetails() {
      const details = [];

      this.selectedRequest.particulars.forEach((docId) => {
        const docName = this.getDocumentName(docId);

        const fee = this.getDocumentFee(docId);
        const hasSearchFee = this.isSearchFeeApplicable(docId);
        const searchFee = hasSearchFee ? this.getSearchFee(docId) : 0;

        if (fee > 0) {
          details.push({
            document: docName,
            amount: fee,
          });
        }

        if (hasSearchFee && searchFee > 0) {
          details.push({
            document: `${docName} - Search Fee`,
            amount: searchFee,
          });
        }
      });

      if (this.selectedRequest.is_postal_required && this.postalCharges > 0) {
        details.push({
          document: "Postal Fee",
          amount: this.postalCharges,
        });
      }

      return details;
    },

    async handleApprove() {
      if (this.selectedRequest.status === "Approved") {
        this.submitApprove();
        return;
      }
      if (!this.isFormValid) return;

      const documentAmountDetails = this.buildDocumentAmountDetails();
      this.approvalLoading = true;
      const data = {
        status: "Approved",
        amount: this.confirmAmount,
        postal_charges: this.postalCharges,
        pay_start_date: this.selectedRequest.pay_start_date,
        pay_end_date: this.selectedRequest.pay_end_date,
        is_postal_required: this.selectedRequest.is_postal_required,
        document_amount_details: documentAmountDetails,
      };

      try {
        const response = await this.$axios.put(
          `student_document_requests/${this.selectedRequest.id}`,
          { student_document_request: data },
        );

        this.showSuccess(response.data.data || "Request approved successfully");
        this.closeDialog();
        await this.getStudentRequests();
      } catch (error) {
        this.showError("Failed to approve request", error);
      } finally {
        this.approvalLoading = false;
      }
    },

    async submitApprove() {
      this.approvalLoading = true;
      const data = {
        pay_start_date: this.selectedRequest.pay_start_date,
        pay_end_date: this.selectedRequest.pay_end_date,
        is_postal_required: this.selectedRequest.is_postal_required,
        status: "Date Requested",
      };
      const response = await this.$axios.put(
        `student_document_requests/${this.selectedRequest.id}`,
        { student_document_request: data },
      );
      this.showSuccess(response.data.data || "Request approved successfully");
      this.approvalLoading = false;
      this.closeDialog();
      await this.getStudentRequests();
    },

    async handleReject() {
      if (!this.rejectionReason || !this.rejectionReason.trim()) return;

      this.rejectLoading = true;

      try {
        const response = await this.$axios.put(
          `student_document_requests/${this.selectedRequest.id}`,
          {
            student_document_request: {
              status: "Rejected",
              remarks: this.rejectionReason.trim(),
              rejected_by: this.currentUser.id,
            },
          },
        );

        this.showSuccess(response.data.data || "Request rejected successfully");
        this.closeRejectDialog();
        this.closeDialog();
        await this.getStudentRequests();
      } catch (error) {
        this.showError("Failed to reject request", error);
      } finally {
        this.rejectLoading = false;
      }
    },

    showSuccess(message) {
      this.$store.commit("showSnackbar", {
        message,
        color: "success",
      });
    },

    showError(message, error) {
      this.$store.commit("showSnackbar", {
        message: error?.response?.data?.message || message,
        color: "error",
      });
    },

    customFilter(value, search, item) {
      if (!search) return true;

      const searchLower = search.toLowerCase();
      const studentName = item.student_info?.name?.toLowerCase() || "";
      const usn = item.usn_id?.toLowerCase() || "";
      const status = item.status?.toLowerCase() || "";

      return (
        studentName.includes(searchLower) ||
        usn.includes(searchLower) ||
        status.includes(searchLower)
      );
    },

    currentDate(date) {
      const d = new Date(date);
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    normalizeDocumentAmountDetails(details = []) {
      return details.map((item) =>
        typeof item === "string" ? JSON.parse(item) : item,
      );
    },
    getApprovedFeeMap(item) {
      const details = this.normalizeDocumentAmountDetails(
        item.document_amount_details || [],
      );

      return details.reduce((acc, row) => {
        acc[row.document] = row.amount;
        return acc;
      }, {});
    },

    getApprovedPostalFee(item) {
      const map = this.getApprovedFeeMap(item);
      return map["Postal Fee"] || map["Postal Charges"] || 0;
    },

    getApprovedSearchFee(item, docName) {
      const map = this.getApprovedFeeMap(item);
      return map[`${docName} - Search Fee`] || 0;
    },

    getApprovedTotal(item) {
      return (item.document_amount_details || []).reduce((total, row) => {
        const parsed = typeof row === "string" ? JSON.parse(row) : row;
        return total + (Number(parsed?.amount) || 0);
      }, 0);
    },
    calculateApprovedSubtotal(docId, docName) {
      const details = this.normalizeDocumentAmountDetails(
        this.selectedRequest.document_amount_details || [],
      );

      const docFeeDetail = details.find((d) => d.document === docName);
      const baseFee = docFeeDetail ? docFeeDetail.amount : 0;

      const searchFeeKey = `${docName} - Search Fee`;
      const searchFeeDetail = details.find((d) => d.document === searchFeeKey);
      const searchFee = searchFeeDetail ? searchFeeDetail.amount : 0;

      return baseFee + searchFee;
    },
    async download() {
      this.downloadloading = true;
      this.$axios
        .get(`/download_student_document_requests`, {
          responseType: "blob",
          params: {
            filename: "document_requests.csv",
          },
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "text/csv" }),
            url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "document_requests.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.downloadloading = false;
        });
    },
    async downloadTemplate() {
      this.$axios
        .get(`/download_tracking_details_template`, {
          responseType: "blob",
          params: {
            filename: "document_requests.csv",
          },
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "text/csv" }),
            url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "document_requests.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        });
    },
    async downloadBulkRequestTemplate() {
      const headers = [
        "S.No",
        "PGM",
        "PGM Sub",
        "Registration No",
        "Source",
        "LMS",
        "Basket",
        "SAP/IGNITE ID",
        "ABC ID",
        "DEB ID",
        "Batch",
        "Name",
        "Primary Mail Id",
        "CT Mail Id",
        "Mobile No",
        "Current Sem",
        "Fee Payment Semester",
        "Tuition Fees to be collected",
        "Concession",
        "Excess Payment",
        "Applicable Tuition Fee",
        "Re-Admission Fee",
        "Convocation Fee",
        "Fee Status",
        "Final Status",
        "Current Status",
        "Existing Remark",
        "Payment Type",
        "Sub Rem",
        "Postal Fee",
        "Request Particulars",
        "Transaction ID",
        "Transaction Date",
      ];

      const csvContent = headers.join(",") + "\n";

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "postal_bulk_request_template.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },

    triggerBulkFileUpload() {
      this.$refs.bulkFileInput.click();
    },

    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.loading = true;

      this.selectedFile = file;
      this.selectedFilename = file.name;

      const formData = new FormData();
      formData.append("csv_file", this.selectedFile, this.selectedFilename);

      await this.$axios
        .post(`/upload_documents_tracking_details`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.loading = false;

          if (response.status === 201) {
            this.$emit("error", response.data);
            this.selectedFile = null;
            this.uploadDialog = false;
            this.$store.commit("showSnackbar", {
              message: "File imported successfully",
              color: "success",
            });
            return;
          }

          this.$store.commit("showSnackbar", {
            message: response.data?.message || "Uploaded Successfully",
            color: "success",
          });

          this.getStudentRequests();

          this.selectedFile = null;
          this.uploadDialog = false;

          if (this.init) this.init();

          this.$emit("uploaded");
        })
        .catch(async (error) => {
          this.loading = false;

          let errorMessage = "Upload failed";

          if (error.response) {
            if (error.response.data?.message) {
              errorMessage = error.response.data.message;
            } else if (error.response.data?.error) {
              errorMessage = error.response.data.error;
            } else if (error.response.status === 400) {
              errorMessage = "Invalid file format or headers";
            }

            if (errorMessage.toLowerCase().includes("invalid headers")) {
              this.selectedFile = null;
            }
          } else if (error.request) {
            errorMessage = "No response from server";
          } else {
            errorMessage = error.message;
          }

          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });

          console.error("Upload error:", error);
        })
        .finally(() => {
          event.target.value = "";
        });
    },

    openBulkApproveDialog() {
      if (!this.selectedRows.length) {
        this.showError("No records selected");
        return;
      }

      this.bulkFromDate = null;
      this.bulkToDate = null;

      this.showBulkStartDatePicker = false;
      this.showBulkEndDatePicker = false;

      this.bulkApproveDialog = true;
    },

    getSelectedIds() {
      return this.selectedRows.map((item) => item.id);
    },
    async submitBulkApprovalStatus(status) {
      const ids = this.selectedRows.map((item) => item.id);

      try {
        this.loading = true;

        await this.$axios.put(`/bulk_approval_status_document_requests`, {
          ids,
          pay_start_date: this.bulkFromDate,
          pay_end_date: this.bulkToDate,
          status: status,
        });

        this.showSuccess(`Bulk ${status} successful`);

        this.bulkApproveDialog = false;
        this.selectedRows = [];
        await this.getStudentRequests();
      } catch (error) {
        this.showError("Bulk approval failed", error);
      } finally {
        this.loading = false;
      }
    },

    async handleBulkFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.loading = true;

      this.selectedFile = file;
      this.selectedFilename = file.name;

      const formData = new FormData();
      formData.append("csv_file", this.selectedFile, this.selectedFilename);

      await this.$axios
        .post(`/upload_bulk_document_requests`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.loading = false;

          if (response.status === 201) {
            this.$emit("error", response.data);
            this.selectedFile = null;
            this.bulkRequestDialog = false;
            this.$store.commit("showSnackbar", {
              message: "File imported successfully",
              color: "success",
            });
            return;
          }

          this.$store.commit("showSnackbar", {
            message: response.data?.message || "Uploaded Successfully",
            color: "success",
          });

          this.getStudentRequests();
          this.bulkRequestDialog = false;

          this.selectedFile = null;
          this.uploadDialog = false;

          if (this.init) this.init();

          this.$emit("uploaded");
        })
        .catch(async (error) => {
          this.loading = false;

          let errorMessage = "Upload failed";

          if (error.response) {
            if (error.response.data?.message) {
              errorMessage = error.response.data.message;
            } else if (error.response.data?.error) {
              errorMessage = error.response.data.error;
            } else if (error.response.status === 400) {
              errorMessage = "Invalid file format or headers";
            }

            if (errorMessage.toLowerCase().includes("invalid headers")) {
              this.selectedFile = null;
            }
          } else if (error.request) {
            errorMessage = "No response from server";
          } else {
            errorMessage = error.message;
          }

          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });

          console.error("Upload error:", error);
        })
        .finally(() => {
          event.target.value = "";
        });
    },
  },
};
</script>

<style scoped>
.row-height-50 >>> tbody tr {
  height: 50px;
}

.caption {
  font-size: 0.75rem;
}

.v-chip {
  font-size: 0.75rem;
  height: 22px;
}

.compact-field >>> .v-input__control {
  min-height: 36px !important;
}

.compact-field >>> .v-text-field__details {
  display: none;
}

.compact-field >>> input {
  padding: 6px 8px !important;
  font-size: 0.875rem;
}

.v-data-table::v-deep th {
  padding-right: 0px !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  padding-right: 0px !important;
}
</style>
